import { render, staticRenderFns } from "./reserveOrder.vue?vue&type=template&id=15b3e37a&scoped=true"
import script from "./reserveOrder.vue?vue&type=script&lang=js"
export * from "./reserveOrder.vue?vue&type=script&lang=js"
import style0 from "./reserveOrder.vue?vue&type=style&index=0&id=15b3e37a&prod&lang=less&scoped=true"
import style1 from "./reserveOrder.vue?vue&type=style&index=1&id=15b3e37a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b3e37a",
  null
  
)

export default component.exports